module.exports = __webpack_public_path__ + "static/media/arrow-hand-min.933b7651.png";